export default "__VITE_ASSET__DepK9XE7__"